import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';
 import IconClone from 'react-icons/lib/fa/clone';

import * as actions from '../../actions/tiposcambio';
import Modal from "./Modal";
import _ from "lodash";
import {api} from '../../actions/_request';
import swal from 'sweetalert2'
import Menu from '../facturacion/menu.js';

const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var venta="";
        var compra="";
        var final="";
        var inicio="";
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "venta":
              venta=filtered[i].value;
              break;
            case "compra":
              compra=filtered[i].value;
              break;            
            case "inicio":
              inicio=filtered[i].value;
              break;
            case "final":
              final=filtered[i].value;
              break;             
          }
        }
        api().get(`/tipo_cambios/conteo?inicio=${inicio}&venta=${venta}&compra=${compra}&final=${final}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/tipo_cambios/busqueda?inicio=${inicio}&venta=${venta}&compra=${compra}&final=${final}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};
class TiposCambio extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
             data: [],
             pages: null,
             loading: true

        };
        this.toggle 			= this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
    }
    get_cliente(cliente = null){
    
    
          
  
  }
 fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      this.props.get(res.rows);
    });
  }
   verificar(evt, prospectoid = null, title = "Agregar Tipo de Cambio",estado)
    {
      if(estado==="Activo"){
        this.toggle(evt,prospectoid,title);
      }else{

         swal({
        title: 'Estas seguro?',
        text: "Se Desactivara el Tipo de Cambio actual y se  Activara Este",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
         cancelButtonText: 'Cancelar!'
      }).then((result) => {
        if (result.value) {
            
        this.props.copiar(prospectoid, (data) => {
                    swal({
                        title: 'Tipo de Cambio',
                        text: 'Tipo de Cambio Copiado correctamente!',
                        type: 'success',
                        // showCancelButton: true,
                        // confirmButtonColor: '#3085d6',
                        // cancelButtonColor: '#d33',
                        confirmButtonText: 'Continue!'
                    }).then((result) => {
                        if (result.value) {

                        }
                    })
                }); 
        }
      })

        

      }
    }
   toggle(evt, prospectoid = null, title = "Agregar Tipo de Cambio")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }

    componentDidMount() {

       // this.props.get();
    }

    render() {
 const { data, pages, loading } = this.state;
        return(
            <div className="view">
            <Menu props={this.props}/>

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase"> Tipos de Cambio</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="text-right">
                                <Button color="success" className="mb-2" onClick={this.toggle}>
                                    <IconPersonAdd />&nbsp;Agregar
                                </Button>
                            </div>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.verificar(evt, rowInfo.original.value, 'Editar Tipo de Cambio',rowInfo.original.estado)
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Estado', accessor: 'estado', filterable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Venta', accessor: 'venta', style: { 'textAlign': 'center'}},
                                {Header: 'Compra', accessor: 'compra', style: { 'textAlign': 'center'}},
                                {Header: 'Inicio', accessor: 'inicio', style: { 'textAlign': 'center'}},
                                {Header: 'Final', accessor: 'final', style: { 'textAlign': 'center'}},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:150,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.verificar(evt, row.original.value, 'Editar Tipo de Cambio',row.original.estado)}>
                                                    {row.original.estado==="Activo"? <IconEdit /> : <IconClone /> }
                                                </Button>{' '}
                                               
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.tiposcambio.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10}
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                 get_cliente={this.get_cliente}
                />
                }
                 

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        tiposcambio : state.tiposcambio,
    }
};

export default connect(mapStateToProps, actions)(TiposCambio)


// WEBPACK FOOTER //
// ./src/views/tiposcambio/index.js